<template>
    <v-app v-if="isLoading">
        <loading />
    </v-app>
    <div v-else>
        <v-container fluid>
            <v-row>
                <v-col cols="12" lg="9">
                    <v-card
                        class="gray rounded-xl rounded-tr-0 EK-card mb-4 pb-4" v-if="latestAds.length > 0"
                    >
                        <v-card-title class="text-IMTGray">
                            <h5 class="m-0">آخر الإعلانات</h5>
                            <router-link to="/ad/1/-1" class="mr-auto">
                                <v-btn text color="IMThemeGray">
                                    المزيد
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                            </router-link>
                        </v-card-title>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="12" :sm="index == 2 ? 12 : 6" md="4" v-for="(ad, index) in latestAds" :key="ad.id" >
                                    <v-card
                                        class="mx-auto EK-card rounded-xl EK-shadow IMTOrange"
                                        height="250"
                                    >
                                        <v-img
                                            class="w-100 h-100"
                                            :src="
                                                !ad.image
                                                    ? placeholder
                                                    : ad.image.path.replace('~', domainHost)
                                            "
                                        ></v-img>
                                        
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-card>
                    <v-row>
                        <v-col cols="12" lg="12" md="12">
                            <v-container
                                class="mx-auto gray rounded-xl box-shadow"
                            >
                                <v-row>
                                    <v-col cols="12" md="4" sm="3">
                                        <v-card
                                            class="IMThemeOrange rounded-xl rounded-tr-0 EK-card pb-1"
                                        >
                                            <div class="position-relative rounded-xl rounded-tr-0 overflow-hidden">
                                                <div class="overlay IMThemeGray" style="z-index: 0"></div>
                                                <img src="/media/svg/aside-icon/category.svg"
                                                    alt="" height="140" class="w-100 position-relative" style="z-index: 1">
                                            </div>
                                            <v-card-text class="white mt-3 text-IMTGray rounded-xl rounded-tr-0 d-flex flex-column justify-content-center align-items-center">
                                                <h5 class="m-1 mb-0">عدد التصنيفات</h5>
                                                <h4 class="pb-4 pt-8">
                                                    {{ categoriesCount }}
                                                </h4>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="3">
                                        <v-card
                                            class="IMThemeOrange rounded-xl rounded-tl-0 EK-card pb-1"
                                        >
                                            <div class="position-relative rounded-xl rounded-tl-0 overflow-hidden">
                                                <div class="overlay IMThemeGray" style="z-index: 0"></div>
                                                <img src="/media/svg/aside-icon/shop.svg" alt="" height="140" class="w-100 position-relative" style="z-index: 1">
                                            </div>
                                            <v-card-text class="white mt-3 text-IMTGray rounded-xl rounded-tl-0 d-flex flex-column justify-content-center align-items-center">
                                               <h5 class="m-0">عدد المشتركين الكلي</h5>
                                                <h4 class="py-1 mb-0">
                                                    {{ shopsCount }}
                                                </h4>
                                                  <h5 class="m-0">(مع خريطة)</h5>
                                                <h4 class="py-1 mb-0">
                                                    {{ shopsWithMapCount }}
                                                </h4>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="3">
                                        <v-card
                                            class="IMThemeOrange rounded-xl rounded-tr-0 EK-card pb-1"
                                        >
                                            <div class="position-relative rounded-xl rounded-tr-0 overflow-hidden">
                                                <div class="overlay IMThemeGray" style="z-index: 0"></div>
                                                <img src="/media/svg/aside-icon/account.svg"
                                                    alt="" height="140" class="w-100 position-relative p-1" style="z-index: 1">
                                            </div>
                                            <v-card-text class="white mt-3 text-IMTGray rounded-xl rounded-tr-0 d-flex flex-column justify-content-center align-items-center">
                                                <h5 class="m-1 mb-0">عدد المستخدمين</h5>
                                                <h4 class="pb-4 pt-8">
                                                    {{ mobileUsersCount }}
                                                </h4>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="3">
                    <v-row>
                        <v-col cols="12" md="6" lg="12">
                            <v-card
                                style="max-width: 400px"
                                class="mx-auto IMThemeGray text-white rounded-xl rounded-tl-0 EK-card"
                            >
                                <v-card-title>
                                    <h5 class="m-0">آخر الاشعارات</h5>
                                    <router-link to="/notification" class="mr-auto">
                                        <v-btn text color="white">
                                            المزيد
                                            <v-icon>mdi-chevron-left</v-icon>
                                        </v-btn>
                                    </router-link>
                                </v-card-title>
                                <v-card-text>
                                    <router-link
                                        v-for="(item, index) in latestNotifications"
                                        :key="index"
                                        :to="{ path: `/notification/details/${item.shopId}/active-notification/${item.id}`}"
                                        class="text-IMTGray"
                                        style="text-decoration: none;"
                                    >
                                        <v-card-text
                                            :class="{
                                                'mt-4': index != 0
                                            }"
                                            class="white rounded-xl rounded-tl-0 pt-4 text-right"
                                        >
                                            <ul
                                                class="list-unstyled p-0 m-0 d-flex justify-space-between pb-3"
                                            >
                                                <li class="d-flex align-items-center">
                                                    <img
                                                        src="/media/svg/edit.svg"
                                                        alt="edit"
                                                        width="24"
                                                        class="ml-1"
                                                    />
                                                    <strong>{{
                                                        !item.shopName
                                                            ? "بلا مشترك"
                                                            : item.shopName
                                                    }}</strong>
                                                </li>
                                                <li class="d-flex align-items-center">
                                                    <img
                                                        src="/media/svg/calendar.svg"
                                                        alt="calendar"
                                                        width="22"
                                                        class="ml-1"
                                                    />
                                                    <strong>{{
                                                        new Date(
                                                            item.createdAt
                                                        ).toISOString().substr(0, 10)
                                                    }}</strong>
                                                </li>
                                            </ul>
                                            <p
                                                class="lead m-0 text-justify text-noti-home"
                                                style="line-height: 1.5"
                                            >
                                             <span>
                                                {{ item.body }}
                                             </span>
                                            </p>
                                        </v-card-text>
                                    </router-link>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" lg="12" v-if="!!latestOffers[0]">
                            <v-card
                                style="max-width: 400px"
                                class="mx-auto IMThemeGray text-white rounded-xl rounded-tl-0 EK-card"
                            >
                                <v-card-title>
                                    <h5 class="m-0">آخر العروض</h5>
                                    <router-link to="/ad/1/-1" class="mr-auto">
                                        <v-btn text color="white">
                                            المزيد
                                            <v-icon>mdi-chevron-left</v-icon>
                                        </v-btn>
                                    </router-link>
                                </v-card-title>
                                <v-card-text class="text-right rounded-tl-0">
                                    <v-row>
                                        <v-col cols="12" v-for="(offer, i) in latestOffers" :key="i">
                                            <v-card
                                                class="IMThemeOrange rounded-xl rounded-tl-0 EK-card"
                                            >
                                                <div class="position-relative rounded-xl rounded-tl-0 overflow-hidden">
                                                    <img :src="!offer.image ? placeholder :
                                                            (!!offer.image.path ?
                                                            (offer.image.path.replace('~', domainHost )) :
                                                            offer.image.base64)"
                                                        alt="" height="240" class="w-100">
                                                    <div class="overlay orange"></div>
                                                </div>
                                                <v-card-text class="white mt-3 text-IMTGray rounded-xl rounded-tl-0 d-flex flex-column justify-content-center align-items-center">
                                                    {{offer.description}}
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<style lang="scss" scoped>
.box-shadow{
box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
</style>
<style lang="scss">
.text-noti-home{
    span{
        margin: auto;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        width: 200px;
        text-overflow: ellipsis;
    }
}
</style>
<script>
import loading from "@/components/loading";
import { mapActions, mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
export default {
    components: {
        loading,
         apexchart: VueApexCharts,
    },
    created() {
        this.fetchHome();
        this.setBreadcrumbs([
            {
                text: "الرئيسية",
                disabled: false,
                href: "/dashboard"
            }
        ]);
      this.fetchDashNotifications();
    },
    computed: {
        ...mapGetters([
            "latestAds",
            "latestOffers",
            "latestNotifications",
            "shopsCount",
            "mobileUsersCount",
            "shopsWithMapCount",
            "categoriesCount",
            "isLoading",
            "placeholder",
            "domainHost",
        ])
    },
    methods: {
        ...mapActions(["fetchHome", "setBreadcrumbs","fetchMainReport","fetchDashNotifications"])
    }
};
</script>
